import { useEffect, useState } from 'react';
import { bridge } from '../utils';

/**
 * GrowthBook feature flag 값을 가져오는 훅
 *
 * - JSON 파싱 성공 시 T 타입으로 반환
 * - JSON 파싱 실패 시 원본 string 반환
 * - 응답 전 또는 값 없음: null
 *
 * @example
 * const value = useGrowthBookFeatureValue<{ exp_group: string }>('exp-10011');
 * if (value !== null) {
 *   const group = value.exp_group; // 'A' | 'B' | 'C' | ...
 * }
 *
 * @warning 단순 피쳐플래그용도의 boolean 타입은 useFeatureFlag 훅을 사용하세요. 이 훅은 boolean이 아닌 값에 대한 실험에 적합합니다.
 */
export const useGrowthBookFeatureValue = <T = unknown>(key: string) => {
  const [value, setValue] = useState<T | null>(null);

  useEffect(() => {
    bridge.getFeatureFlag({ key }).then(result => {
      if (result == null) {
        setValue(null);
        return;
      }
      try {
        setValue(JSON.parse(result) as T);
      } catch {
        setValue(result as T);
      }
    });
  }, [key]);

  return value;
};
